module.exports = __webpack_public_path__ + "assets/img/video-popup.a4b401c3.png";